import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

import { Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ConfigurationService } from '@sondermind/configuration';
import { FormlibFileUploadService } from '@sondermind/data-access/formlib';

@Injectable({
  providedIn: 'root'
})
export class UploadDataService implements FormlibFileUploadService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpClient,
    private location: Location,
  ) { }

  upload(path: string, file: Blob | File): Observable<string> {
    // Use temporary_uploads endpoint for one-page-checkout (no auth required)
    const currentPath = this.location.path();
    const endpoint = currentPath.includes('one-page-checkout')
      ? '/v2/temporary_uploads'
      : '/v2/uploads';
    const url = `${this.configurationService.env.apiBase}${endpoint}`;
    const body = { path };

    return this.http
      .post<{ upload_to: string; download_from: string; }>(url, body, { observe: 'body' })
      .pipe(
        switchMap((x) => this.http
          .put(x.upload_to, file)
          .pipe(
            map(() => x.download_from)
          )),
        catchError((err, _caught) => {
          if (err instanceof HttpErrorResponse) {
            const realError = new Error(`Error while performing upload! (${err.status} ${err.statusText}) ${err.error}`);
            return throwError(() => realError);
          }

          return throwError(err);
        })
      );
  }
}
